import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import CompanyBusinessSearcher from '../../../../../../../lib/common/CompanyBusinessSearcher';
import { Filter } from '../../../../../../../lib/common/GlobalSearcher';
import DocumentSelector from './components/DocumentSelector';
import ProductSelector from './components/ProductSelector';
import Simulator from './components/Simulator';
import DatesSelector from './components/DatesSelector';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { AuthState } from '../../../../../../../services/redux/authSlice';
import { expressGetCompanyConfig } from '../../../../../../../lib/api/express/company';
import { getCompanyConfig } from '../../../../../../../lib/api/company';
import CenteredCircularProgress from '../../../../../../../lib/designSystem/CircularProgress';
import { getAvailableArrearTables } from '../../../../../../../lib/api/factoring';
import {
  getDocumentsAvailableForConfirming,
  createConfirmingOperation,
} from '../../../../../../../lib/api/confirming';
import ConfirmationDialog from './components/ConfirmationDialog';
import { showAlert } from '../../../../../../../lib/functions/utils';

function getTodayUTC(): Date {
  const now = new Date();
  return new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
  );
}

const NewOperation = (props: any) => {
  const { open, setOpen, parentSetUp } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [business, setBusiness] = useState<any>({});
  const [searched, setSearched] = useState<boolean>(false);
  const [step, setStep] = useState<number>(-1);

  // Documents
  const [documents, setDocuments] = useState<any[]>([]);
  const [filteredDocuments, setFilteredDocuments] = useState<any[]>([]);
  const [selected, setSelected] = useState<any[]>([]);
  const [selectedDocuments, setSelectedDocuments] = useState<any[]>([]);

  const [productType, setProductType] = useState<string>('');
  // Search filters
  const [searchBusiness, setSearchBusiness] = useState<string>('all');
  const [searchFolio, setSearchFolio] = useState<string>('');

  const [operationDate, setOperationDate] = useState<string>(
    getTodayUTC().toISOString().split('T')[0],
  );
  const [operationDateDate, setOperationDateDate] =
    useState<Date>(getTodayUTC());
  const [exchangeDay, setExchangeDay] = useState<boolean>(false);

  const [canForcePaymentDate, setCanForcePaymentDate] =
    useState<boolean>(false);
  const [minimumDays, setMinimumDays] = useState<number>(0);

  const [requestForCreation, setRequestForCreation] = useState<any>(null);
  const [availableArrearTables, setAvailableArrearTables] = useState<any[]>([]);
  const [requestConfiguration, setRequestConfiguration] = useState({
    expensesHasIVA: false,
  });

  const [openConfirmationDialog, setOpenConfirmationDialog] =
    useState<boolean>(false);

  const getRestrictions = async () => {
    let system_operations_forcePaymentDate,
      system_operations_minimunDays,
      pruffConnect_operations_uploadPdfMandatory;
    if (user?.express) {
      if (!user.clientId) {
        return {
          system_operations_forcePaymentDate,
          system_operations_minimunDays,
          pruffConnect_operations_uploadPdfMandatory,
        };
      }
      ({
        system_operations_forcePaymentDate,
        system_operations_minimunDays,
        pruffConnect_operations_uploadPdfMandatory,
      } = await expressGetCompanyConfig(dispatch, user.clientId, [
        'system_operations_forcePaymentDate',
        'system_operations_minimunDays',
        'pruffConnect_operations_uploadPdfMandatory',
      ]));
    } else {
      system_operations_forcePaymentDate = await getCompanyConfig(
        dispatch,
        'system_operations_forcePaymentDate',
      );
      system_operations_minimunDays = await getCompanyConfig(
        dispatch,
        'system_operations_minimunDays',
      );
      pruffConnect_operations_uploadPdfMandatory = await getCompanyConfig(
        dispatch,
        'pruffConnect_operations_uploadPdfMandatory',
      );
    }
    return {
      system_operations_forcePaymentDate,
      system_operations_minimunDays,
      pruffConnect_operations_uploadPdfMandatory,
    };
  };

  const fetchDateRestrictionsConfig = async () => {
    try {
      const {
        system_operations_forcePaymentDate,
        system_operations_minimunDays,
      } = await getRestrictions();

      setCanForcePaymentDate(Number(system_operations_forcePaymentDate) === 1);
      if (system_operations_minimunDays)
        setMinimumDays(Number(system_operations_minimunDays));
    } catch (error) {
      console.error('Error fetching date restrictions config', error);
    }
  };

  const setUpAvailableArrearTables = async () => {
    const availableArrearTables = await getAvailableArrearTables(dispatch);
    setAvailableArrearTables(availableArrearTables);
  };

  const createRequestForCreation = () => {
    const documentsForRequest = selectedDocuments.map((document: any) => {
      const date =
        typeof document.paymentDate === 'string'
          ? new Date(document.paymentDate)
          : document.paymentDate;
      return {
        id: document.id,
        amount: document.amount,
        amountDocument: 0,
        amountFinanced: 0,
        amountRetention: 0,
        businessIdentifier: document.businessIdentifier,
        businessName: document.businessName,
        issuer: document.issuer,
        issuedDate: document.issuedDate,
        issuedDateShortString: document.issuedDate.split('T')[0],
        daysToCount: document.daysToCount,
        confirmDate: document.confirmDate,
        cedded: 'No cedido',
        folio: document.folio,
        paymentDate: date,
        paymentDateString: date.toISOString(),
        paymentDateShortString: date.toISOString().split('T')[0],
        subProductName: undefined, // TODO: ?
        cancelDate: document.cancelDate,
        stakeholderName: document.stakeholderName,
        stakeholderIdentifier: document.stakeholderIdentifier,
        active: true,
        code: document.code,
      };
    });

    const documents = documentsForRequest.flat();

    const request = {
      id: null,
      advance: 100,
      rate: 0,
      arrearType: 'lineal',
      arrearRate: 0,
      arrearTableId: null,
      expensesHasIva: requestConfiguration.expensesHasIVA || false,
      stakeholderIdentifier: documents[0].stakeholderIdentifier,
      stakeholderName: documents[0].stakeholderName,
      amount: documents.reduce((acc: any, curr: any) => acc + curr.amount, 0),
      subProduct: 'electronic-invoice-confirming', // TODO: HARDCODED
      subProductName: 'Factura electrónica confirming', // TODO: HARDCODED
      productType: productType,
      documents: documents,
      requestDate: operationDateDate.toISOString(),
    };
    return request;
  };

  const goBack = () => {
    if (step === 1) {
      setBusiness({});
      setSearched(false);
    }
    setStep(step - 1);
  };

  const goNext = () => {
    if (step === 1) {
      const documentselected: any[] = documents.filter((document: any) =>
        selected.includes(document.id),
      );
      if (!documentselected) {
        return;
      }
      setSelectedDocuments(documentselected);
      return setStep(step + 1);
    }
    if (step === 3) {
      if (!checkSelectedDocuments()) {
        return;
      }
      setRequestForCreation(createRequestForCreation());
      return setStep(step + 1);
    }

    setStep(step + 1);
  };

  const filters: Filter[] = [
    {
      type: 'select',
      label: 'Proveedor',
      options: [
        {
          label: 'Todos',
          value: 'all',
        },
        ...documents.map((document: any) => ({
          label: document.businessName,
          value: document.businessIdentifier,
        })),
      ],
      value: searchBusiness,
      setter: setSearchBusiness,
    },
    {
      type: 'text',
      label: 'Folio',
      value: searchFolio,
      setter: setSearchFolio,
    },
  ];

  const filterDocuments = async () => {
    const newFilteredDocuments = documents.filter((document: any) => {
      return (
        (searchBusiness == 'all' ||
          document.businessIdentifier == searchBusiness) &&
        (searchFolio == '' || document.folio == searchFolio)
      );
    });
    setFilteredDocuments(newFilteredDocuments);
  };

  useEffect(() => {
    if (step === 0 && searched) {
      goNext();
    }
  }, [step, searched]);

  const setExpensesHasIVA = async () => {
    try {
      const expensesHasIVAResponse = await getCompanyConfig(
        dispatch,
        'system_accounting_expensesHasIva',
      );
      const expensesHasIVA = expensesHasIVAResponse === '1';
      setRequestConfiguration({
        ...requestConfiguration,
        expensesHasIVA,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const setDocumentsAvailable = async () => {
    setLoading(true);
    const documentsAvailable = await getDocumentsAvailableForConfirming(
      dispatch,
      {
        stakeholderIdentifier: business.identifier,
        subProductTypeId: 'electronic-invoice-confirming',
      },
    );
    setDocuments(documentsAvailable.documents);
    setFilteredDocuments(documentsAvailable.documents);
    setLoading(false);
  };

  useEffect(() => {
    if (business && business.identifier) {
      setDocumentsAvailable();
    }
  }, [business]);

  const setUp = async () => {
    await fetchDateRestrictionsConfig();
    await setUpAvailableArrearTables();
    await setExpensesHasIVA();
    setStep(0);
  };

  useEffect(() => {
    setUp();
  }, []);

  const hiddenGoBack = () => {
    switch (step) {
      case 1:
      case 2:
      case 3:
      case 4:
        return false;
      case 0:
      default:
        return true;
    }
  };

  const disabledGoBack = () => {
    switch (step) {
      case 0:
        return true;
      case 1:
        return false;
      case 2:
        return false;
      case 3:
        return false;
      case 4:
        return false;
      default:
        return true;
    }
  };

  const hiddenGoNext = () => {
    switch (step) {
      case 0:
        return true;
      case 1:
        return false;
      case 2:
        return false;
      case 3:
        return false;
      default:
        return true;
    }
  };

  const checkSelectedDocuments = () => {
    const duplicatedFolios: string[] = [];
    selectedDocuments.forEach((document: any) => {
      if (!document.oldSubDocuments) return;
      if (document.subDocuments && document.subDocuments.length) {
        const subFolios = document.oldSubDocuments.map(
          (subDocument: any) => subDocument.folio,
        );
        document.subDocuments.forEach((subDocument: any) => {
          const key = `${document.folio}-${subDocument.folio}`;
          if (subFolios.includes(key)) {
            duplicatedFolios.push(key);
          }
        });
      }
    });
    if (duplicatedFolios.length) {
      return false;
    }

    const paymentDate = selectedDocuments.every((document: any) => {
      if (document.subDocuments && document.subDocuments.length) {
        return document.subDocuments.every((subDocument: any) => {
          return subDocument.paymentDate;
        });
      } else {
        return document.paymentDate;
      }
    });
    if (!paymentDate) {
      return false;
    }
    const amount = selectedDocuments.every((document: any) => {
      if (document.subDocuments && document.subDocuments.length) {
        return document.subDocuments.every((subDocument: any) => {
          return subDocument.amount;
        });
      } else {
        return document.amount;
      }
    });
    if (!amount) {
      return false;
    }
    return true;
  };

  const disabledGoNext = () => {
    switch (step) {
      case 0:
        return true;
      case 1:
        if (selected.length === 0) {
          return true;
        }
        return false;
      case 2:
        if (productType === '') {
          return true;
        }
        return false;
      case 3:
        if (operationDate === 'none' || !operationDate) {
          return true;
        }
        if (selectedDocuments.length === 0) {
          return true;
        }
        if (!checkSelectedDocuments()) {
          return true;
        }
        return false;
      default:
        return true;
    }
  };

  const confirmOperation = async () => {
    if (!requestForCreation) {
      return;
    }
    setLoading(true);
    const response = await createConfirmingOperation(dispatch, {
      request: requestForCreation,
    });
    setLoading(false);
    if (response) {
      setOpenConfirmationDialog(false);
      showAlert(dispatch, 'success', 'Operación creada correctamente');
      parentSetUp(response.id || null);
      setOpen(false);
    }
  };

  if (step === -1) {
    return <CenteredCircularProgress />;
  }

  return (
    <Dialog open={open} maxWidth="lg" fullWidth>
      <DialogTitle>Nueva operación de confirming</DialogTitle>
      <DialogContent>
        <div>
          {loading && <CenteredCircularProgress type="dialog" />}
          {step === 0 && (
            <CompanyBusinessSearcher
              setBusiness={setBusiness}
              setSearched={setSearched}
            />
          )}
          {step === 1 && (
            <DocumentSelector
              business={business}
              filteredDocuments={filteredDocuments}
              selected={selected}
              setSelected={setSelected}
              filters={filters}
              filterDocuments={filterDocuments}
            />
          )}
          {step === 2 && (
            <ProductSelector
              business={business}
              selectedDocuments={selectedDocuments}
              productType={productType}
              setProductType={setProductType}
            />
          )}
          {step === 3 && (
            <DatesSelector
              business={business}
              selectedDocuments={selectedDocuments}
              setSelectedDocuments={setSelectedDocuments}
              productType={productType}
              operationDate={operationDate}
              setOperationDate={setOperationDate}
              operationDateDate={operationDateDate}
              setOperationDateDate={setOperationDateDate}
              canForcePaymentDate={canForcePaymentDate}
              minimumDays={minimumDays}
              exchangeDay={exchangeDay}
            />
          )}
          {step === 4 && (
            <Simulator
              requestForCreation={requestForCreation}
              setRequestForCreation={setRequestForCreation}
              availableArrearTables={availableArrearTables}
              requestConfiguration={requestConfiguration}
            />
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          Salir
        </CustomButton>
        <CustomButton
          color="primary"
          onClick={() => goBack()}
          disabled={disabledGoBack()}
          hidden={hiddenGoBack()}
        >
          Volver
        </CustomButton>
        <CustomButton
          color="warning"
          onClick={() => setExchangeDay(!exchangeDay)}
          hidden={step !== 3}
        >
          {exchangeDay ? 'Deshabilitar' : 'Habilitar'} canje
        </CustomButton>
        <CustomButton
          color="primary"
          onClick={() => goNext()}
          disabled={disabledGoNext()}
          hidden={hiddenGoNext()}
        >
          Continuar
        </CustomButton>
        <CustomButton
          color="success"
          onClick={() => setOpenConfirmationDialog(true)}
          disabled={false}
          hidden={step != 4}
        >
          Crear
        </CustomButton>
      </DialogActions>
      <ConfirmationDialog
        open={openConfirmationDialog}
        onClose={() => setOpenConfirmationDialog(false)}
        onConfirm={confirmOperation}
      />
    </Dialog>
  );
};

export default NewOperation;
